export const ACTIVE_FUNDS = [
  {
    fundId: "5",
    campaignId: "67",
    name: "Zakat"
  },
  {
    fundId: "6",
    campaignId: "205",
    name: "Emergency Response"
  },
  {
    fundId: "7",
    campaignId: "203",
    name: "OrphanKind"
  },
  {
    fundId: "8",
    campaignId: "204",
    name: "Feed Our World"
  },
  {
    fundId: "9",
    campaignId: "92",
    name: "Thirst Relief"
  },
  {
    fundId: "16",
    campaignId: "35",
    name: "Where Most Needed/Sadaqah"
  }
];
